
<div class="d-flex justify-content-center align-items-center vh-100" *ngIf="!reportReady">
    <div class="text-center">
        <div class="mb-3">
            <span>Loading {{locationType}} Confirmation....</span>
        </div>
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>

<div *ngIf="pdfUrl">
    <iframe [src]="pdfUrl" width="100%" [height]="iframeHeight"></iframe>
</div>

